export default {
  form: {
    margin: {
      top: '0.75rem',
    },
  },
  subtitle: {
    margin: {
      top: '.25rem',
      bottom: '0',
    },
  },
  page: {
    maxWidth: '56.25rem',
  },
  back: {
    padding: {
      left: '1.5625rem',
    },
    chevron: {
      transform: 'rotate(180deg) translateY(50%)',
      top: '50%',
      left: '0',
      width: '0.9375rem',
      padding: '2.5rem',
    },
  },
  row: {
    margin: {
      bottom: '1.875rem',
    },
    child: {
      margin: {
        vertical: '0',
        horizontal: '.75rem',
      },
      first: {
        margin: {
          left: '0',
        },
      },
      last: {
        margin: {
          right: '0',
        },
      },
      mobile: {
        margin: {
          bottom: '.75rem',
        },
      },
    },
    wide: {
      child: {
        first: {
          width: '66.67%',
        },
      },
    },
    narrow: {
      child: {
        first: {
          width: '33.33%',
        },
      },
    },
    half: {
      child: {
        first: {
          width: '50%',
        },
      },
    },
    full: {
      child: {
        first: {
          width: '100%',
        },
      },
    },
  },
  box: {
    border: {
      thickness: '0.03125rem',
      style: 'solid',
    },
    padding: {
      top: '1.25rem',
      right: '1.25rem',
      bottom: '1.25rem',
      left: '1.25rem',
    },
  },
  column: {
    narrow: {
      width: '15%',
    },
    margin: {
      bottom: '1.875rem',
      bottomShort: '0.9375rem',
    },
  },
  section: {
    margin: {
      vertical: '2rem',
      horizontal: 'auto',
    },
    maxWidth: '56.25rem',
    padding: {
      top: '2.5rem',
      right: '2.5rem',
      left: '2.5rem',
      bottom: '1.25rem',
    },
    width: '100%',
    mobile: {
      padding: {
        top: '1.25rem',
        right: '1.25rem',
        left: '1.25rem',
        bottom: '1.25rem',
      },
    },
  },
  themed: {
    border: {
      thickness: '0.25rem',
      style: 'solid',
    },
  },
};
